import React, { useState } from 'react';
import LazyImage from '../../components/LazyImage';

interface HeroSectionProps {
  onJoinCommunity?: () => void;
}

const HeroSection: React.FC<HeroSectionProps> = () => {
  const [isButtonHovered, setIsButtonHovered] = useState(false);

  const handleButtonMouseEnter = () => {
    setIsButtonHovered(true);
  };

  const handleButtonMouseLeave = () => {
    setIsButtonHovered(false);
  };

  return (
    <section className="relative h-[85vh] flex items-center">
      {/* Background Image */}
      <LazyImage 
        src="/images/AboutUsBanner.webp" 
        alt="Mining site background" 
        className="absolute inset-0 w-full h-full object-cover"
        priority={true}
      />
      
      {/* Dark Overlay */}
      <div 
        className="absolute inset-0 z-10" 
        style={{ backgroundColor: 'rgba(26, 42, 68, 0.75)' }}
      />
      
      {/* Content Overlay */}
      <div className="relative z-10 mx-auto px-4 md:px-10 lg:px-32 w-full">
        <div className="w-full">
          {/* Main Headline */}
          <h1 className="text-[#FFFFFF] text-[30px] md:text-[30px] lg:text-[65px] font-[400] leading-[35px] md:leading-[52px] lg:leading-[80px] lg:mb-2 mb-10 md:mb-8 w-full">
            <span className="font-bold">Rob Bruggeman & The Wealthy Miner Junior Mining Expertise </span>
          </h1>
       
          {/* Body Text */}
          <p className="text-[#FFFFFF] text-[17px] md:text-[20px] lg:text-[26px] font-[600] leading-[24px] md:leading-[30px] lg:leading-[40px] mb-10 md:mb-12 text-justify">
          The Wealthy Miner is a premier mining community on Mighty Networks, led by Rob Bruggeman's a 20-year titan of junior mining investment. Our mission is to empower investors to master mining speculation through Rob's unparalleled mining investment strategies, delivering real-time analysis and collaborative networks to excel in junior mining stocks on the TSX Venture Exchange (TSXV) and TSX.
          </p>
          
          {/* Call-to-Action Button */}
          <a 
            href="https://the-wealthy-miner.mn.co/"
            target="_blank"
            rel="noopener noreferrer"
            className={`inline-block w-full md:w-auto bg-transparent border-2 border-[#FFF] px-8 md:px-16 lg:px-20 py-3 md:py-4 rounded-[10px] text-[14px] md:text-[16px] lg:text-[18px] font-[700] leading-[20px] md:leading-[24px] lg:leading-[32px] transition-all duration-300 transform text-center ${
              isButtonHovered ? 'bg-white text-[#1A2A44] scale-105' : 'text-[#F6F6F6] hover:bg-white hover:text-[#1A2A44] hover:scale-105'
            }`}
            onMouseEnter={handleButtonMouseEnter}
            onMouseLeave={handleButtonMouseLeave}
            aria-label="Join our premium community"
          >
            JOIN OUR PREMIUM COMMUNITY
          </a>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
